export const Colors = {
    anthracite: "#3c3732",
    anthracite5: "#f5f5f5",
    anthracite25: "#cecdcc",
    anthracite50: "#9d9b98",
    blueBright: "#009ba5",
    blueMuted: "#005f69",
    deepViolett: "#540843",
    eggshell: "#ebebea",
    mellowYellow: "#f59b00",
    paleTwo: "#e2e1e1",
    pulsingPurple: "#780a5f",
    teaserBackground: "#790a60",
    pumpkin: "#ea8d00",
    pumpkinTwo: "#d57600",
    radiantRed: "#eb4b0a",
    radiantRedFill: "#fdede6",
    velvet: "#660750",
    white: "#ffffff",
};

export const DefaultStyles = {
    container: {
        display: "flex" as "flex",
        flexWrap: "wrap" as "wrap",
        flexDirection: "column" as "column",
    },
    screenBody: {
        /*width: "calc(100% - 4px)",*/
    },
    h1: {
        fontFamily: "innogyWEB",
        fontSize: 48,
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: Colors.anthracite,
    },
    h2: {
        fontFamily: "innogyWEB",
        fontSize: 37,
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: Colors.anthracite,
    },
    h3: {
        fontFamily: "innogyWEB",
        fontSize: 25,
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: Colors.anthracite,
    },
    h4: {
        fontFamily: "innogyWEB",
        fontSize: 22,
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: Colors.anthracite,
    },
    p: {
        fontFamily: "innogyWEB",
        fontSize: 22,
        fontStretch: "normal",
        fontStyle: "normal",
        letterSpacing: "normal",
        lineHeight: 1.4,
        color: Colors.anthracite,
    },
    hr: {
        border: "none",
        height: "1px",
        color: Colors.anthracite25,
        backgroundColor: Colors.anthracite25,
    },
    pSmall: {
        fontFamily: "innogyWEB",
        fontSize: 18,
        fontStretch: "normal",
        fontStyle: "normal",
        letterSpacing: "normal",
        lineHeight: 1.4,
        width: "100%",
        color: Colors.anthracite50,
    },
    verticalTableTitel: {
        fontFamily: "innogyWEB",
        fontSize: 18,
        fontStretch: "normal",
        fontStyle: "normal",
        letterSpacing: "normal",
        lineHeight: 1.4,
        width: "100%",
        fontWeight: 500,
        color: Colors.anthracite,
    },
    verticalTableText: {
        fontFamily: "innogyWEB",
        fontSize: 18,
        fontStretch: "normal",
        fontStyle: "normal",
        letterSpacing: "normal",
        lineHeight: 1.4,
        width: "100%",
        fontWeight: 300,
        color: Colors.anthracite,
    },
    tableCell: {
        fontFamily: "innogyWEB",
        fontSize: 22,
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.45,
        letterSpacing: "normal",
        color: Colors.anthracite,
    },
    tableCellContent: {
        fontFamily: "innogyWEB",
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.94,
        letterSpacing: "normal",
        color: Colors.anthracite,
    },
    textField: {
        width: 350,
        height: 56,
        borderRadius: 28,
        fontSize: 18,
        paddingRight: 15,
    },
    labledTextfieldLabel: {
        marginLeft: 20,
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
        color: Colors.anthracite,
    },
    labledTextfieldLabelError: {
        marginLeft: 20,
        fontSize: 22,
        fontWeight: 300,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",
        color: Colors.radiantRed,
    },
    navButtonBar: {
        marginTop: 44,
        display: "flex",
        justifyContent: "space-between",
    },
    adornment: {
        marginRight: 30,
    },
    label: {
        marginTop: 0,
        paddingTop: 0,
        fontFamily: "innogyWEB",
        fontSize: 22,
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.45,
        letterSpacing: "normal",
        color: Colors.anthracite,
    },
    error: {
        borderColor: "red",
        color: "red",
    },
    additionalInfoTitle: {
        fontFamily: "innogyWEB",
        fontWeight: 500,
        lineHeight: 1.28,
        color: Colors.anthracite,
        marginTop: 38,
        marginBottom: 18,
        fontSize: 25,
    },
};
